import { motion } from "framer-motion";
import { CreditCard } from "lucide-react";
import { useEffect, useState } from "react";
import { config } from "../../../../utils/config";
import { CreditsTable } from "./components/credits-table";
import { CreateForm } from "./components/create-form";
import { useCreditoAdhocList } from "./hooks/use-credito-adhoc";

export default function CreditoAdhocPage() {
  const fundName = `xama_${config.stage}`;

  const {
    data: creditos = [],
    isLoading,
    refetch,
  } = useCreditoAdhocList(fundName);

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <div className="flex items-center gap-3">
              <motion.div
                className="p-2 rounded-lg bg-primary/10"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              >
                <CreditCard className="h-6 w-6 text-primary" />
              </motion.div>
              <h1 className="text-3xl font-bold text-foreground bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
                Créditos AdHoc — Entrego
              </h1>
            </div>
            <p className="text-muted-foreground mt-1 ml-14">
              Cadastre e gerencie créditos de compra AdHoc por franquia
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="space-y-6"
      >
        <CreateForm dbName={fundName} onSuccess={() => refetch()} />

          <CreditsTable
            data={creditos}
            loading={isLoading}
            dbName={fundName}
            onRefresh={() => refetch()}
          />
        </motion.div>
    </div>
  );
}
